module.exports = __webpack_public_path__ + "static/media/quotesection_layout.315fad0d.png";